import { FooterHelp, Button } from "@shopify/polaris";
import React from "react";

function footer() {

    function callFunction() {

        window.Beacon('open')
        // window.location.href = "javascript:$zopim.livechat.window.show();";
        // window.location.href = "javascript:$zopim.livechat.window.toggle();";
    }

    return (
        <div>
            <FooterHelp>
                Got a feature feedback or request?{" "}
                <Button plain onClick={()=>callFunction()}>Let us know</Button>
                {/* <a
                    href="javascript:$zopim.livechat.window.show();"
                    style={{ textDecoration: "none" }}
                >
                    Let us know
                </a> */}
                {/* <Link onClick={() => callFunction()}>Let us know</Link> */}
            </FooterHelp>
        </div>
    );
}

export default footer;
